import { useParams, Link } from "react-router-dom";
import productsData from "../data/productsData";

export default function ItemDetail() {
    const { productId, itemId } = useParams();

    const product = productsData.find((p) => p.id === productId);
    const item = product?.items.find((i) => i.id === itemId);

    if (!product)
        return <h3 style={{ textAlign: "center", marginTop: "2em", color: "#d9534f" }}>❌ Product not found</h3>;

    if (!item)
        return <h3 style={{ textAlign: "center", marginTop: "2em", color: "#d9534f" }}>❌ Item not found</h3>;

    return (
        <div
            style={{
                marginTop: "1em",
                padding: "2em",
                backgroundColor: "#ffffff",
                borderRadius: "12px",
                boxShadow: "0px 4px 15px rgba(0,0,0,0.1)",
                maxWidth: "700px",
                marginLeft: "auto",
                marginRight: "auto",
                textAlign: "center",
            }}
        >
            {/* Product Name */}
            <h2 style={{ fontSize: "1.8em", fontWeight: "bold", color: "#f0ad4e", marginBottom: "0.5em" }}>
                {product.name}
            </h2>

            {/* Item Name */}
            <h3 style={{ fontSize: "1.5em", color: "#333", marginBottom: "1em" }}>{item.name}</h3>

            {/* Item Description */}
            <p
                style={{
                    fontSize: "1.1em",
                    lineHeight: "1.6",
                    color: "#555",
                    backgroundColor: "#fff7e6",
                    padding: "1.2em",
                    borderRadius: "10px",
                    border: "1px solid #f0ad4e",
                }}
            >
                📦 Details about <strong>{item.name}</strong> coming soon...
            </p>

            {/* Back Link */}
            <div style={{ marginTop: "1.5em" }}>
                <Link
                    to={`../`}
                    style={{
                        textDecoration: "none",
                        backgroundColor: "#28a745",
                        color: "white",
                        padding: "0.8em 1.5em",
                        borderRadius: "8px",
                        fontWeight: "bold",
                        transition: "background-color 0.3s",
                    }}
                    onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = "#1e7e34")}
                    onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = "#28a745")}
                >
                    ⬅ Back to {product.name}
                </Link>
            </div>
        </div>
    );
}
